<div class="modal-header">
  <h5 class="modal-title">Install Application</h5>
  <button type="button"
          class="btn-close"
          aria-label="Close"
          (click)="modal.dismiss('Cross click')"></button>
</div>
<ml-mdm-upload-spinner [status]="uploadProgress ? uploadProgress.progress : 0"
                       [isLoading]="uploadProgress.isLoading">
  <ml-mdm-command-spinner [commandProgress]="commandProgress$">
    <div class="modal-body">
      <era-panel>
        <div class="pb-2">
          <ul class="nav nav-tabs-sm border-bottom">
            <li class="nav-item ps-0">
              <a class="nav-link px-2"
                 [class.active]="appKind === allAppKinds.Default"
                 (click)="appKind = allAppKinds.Default">Applications</a>
            </li>
            <li class="nav-item">
              <a class="nav-link px-2"
                 [class.active]="appKind === allAppKinds.Vpp"
                 (click)="appKind = allAppKinds.Vpp">VPP</a>
            </li>
            <li class="nav-item">
              <a class="nav-link px-2"
                 [class.active]="appKind === allAppKinds.Manual"
                 (click)="appKind = allAppKinds.Manual">Manual</a>
            </li>
          </ul>
        </div>
        @switch (appKind) {
          @case (allAppKinds.Default) {
            <div>
              <ml-mdm-apple-application-list (selectedApplicationChange)="selectApplicationChanged($event)">
              </ml-mdm-apple-application-list>
            </div>
          }
          @case (allAppKinds.Vpp) {
            <div>
              <ml-mdm-vpp-asset-list (selectedAssetChange)="selectApplicationChanged($event)"> </ml-mdm-vpp-asset-list>
            </div>
          }
          @case (allAppKinds.Manual) {
            <div>
              <div class="callout-warning">
                <h6>Use 'Applications' if possible.</h6>
                Manual installation should be used as an exception.
              </div>
              <form (ngSubmit)="onSubmit(package)">
                <div>
                  <label class="form-label pe-2"
                         for="softwarePackage">Software package</label>
                  <input #packageUpload
                         id="softwarePackage"
                         type="file"
                         class="form-control-file"
                         (change)="package = packageUpload.files?.item(0) ?? undefined" />
                </div>
              </form>
            </div>
          }
        }
      </era-panel>
    </div>
    <div class="modal-footer">
      <button type="submit"
              class="btn btn-primary align-self-end"
              (click)="onSubmit(package)">
        <fa-icon icon="file-upload"></fa-icon>
        <span class="ms-2"
              i18n>Install</span>
      </button>
    </div>
  </ml-mdm-command-spinner>
</ml-mdm-upload-spinner>